import { combineReducers } from 'redux';
import storage from './storage';

export default combineReducers({
  storage,
});
